module.exports = __webpack_public_path__ + "static/media/21.70c0a2f2.jpg";